module.exports = __webpack_public_path__ + "img/forbidden.7ac8a1b6.png";